import React from "react";
// import { Link } from "gatsby"
import { Markdown } from "../../../utils/Markdown";

const CTAOne = ({ data }) => {
	return (
		<>
			<section className="mt-10 mx-auto  max-w-screen-xl items-center mb-20 justify-between px-4">
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4 ">
					{data.map((service, index) => {
						return (
							<div
								key={index}
								className="col-span-1  md:col-span-2  mb-6  duration-300"
							>
								<Markdown Output={service} replaceH1={true} />

								{/* <h6 className="  text-xl text-black mb-2 text-center  ">
                  {service.title}
                </h6> */}
							</div>
						);
					})}
				</div>
			</section>
		</>
	);
};

export default CTAOne;
